<template>
	<BaseLayout :footer-full="true" :include-padding="false" :background-color-class="`bg-color-white`">
		<BasePlaceHolder
			:line-count="4"
			:section-count="6"
			:placehold="loading"
			:class="{ 'col-8-md col-offset-2-md pt-300 pb-300': loading }"
		>
			<ArticleContent v-if="article" :article="article" />
		</BasePlaceHolder>

		<template #footer>
			<BasePlaceHolder
				v-if="article?.flatFooterDisclaimers"
				:line-count="3"
				:placehold="loading"
				:class="{ container: loading }"
			>
				<FooterFull :disclaimers="article.flatFooterDisclaimers" />
			</BasePlaceHolder>
		</template>
	</BaseLayout>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getSanityBlogArticle } from '@api/sanity/graphql/blog-education-center';
import ArticleContent from '@components/blog/article-content.vue';
import FooterFull from '@components/footer/footer-full.vue';
import { appCloudfrontPath } from '@constants';
import { SanityArticle } from 'types/sanity/education-center';

const route = useRoute();
const router = useRouter();

const headControl = useHead({
	script: [`window.prerenderReady = false;`]
});

const loading = ref(true);

const article = ref<SanityArticle | null>(null);

async function setup(): Promise<void> {
	try {
		const sanityArticle = await getSanityBlogArticle(route, 'article-view');
		article.value = sanityArticle;
	} catch {
		await router.push({ path: '/404' });
	}

	if (article.value) {
		headControl?.patch({
			title: article.value.title,
			meta: [
				{ property: 'og:title', content: article.value.title },
				{ name: 'description', content: article.value?.abstract ?? '' },
				{ property: 'og:description', content: article.value?.abstract ?? '' },
				{
					property: 'og:image',
					content:
						article.value.coverImage && article.value.coverImage.asset.url
							? article.value.coverImage.asset.url
							: `${appCloudfrontPath}/images/global/Fundrise-og-image.jpg`
				}
			],
			script: [`window.prerenderReady = true;`]
		});

		loading.value = false;
	} else {
		await router.push({
			path: '/404'
		});
	}
}

setup();

onUnmounted(() => {
	headControl?.dispose();
});
</script>
